module.exports = __webpack_public_path__ + "static/media/ZW.f7cbd888.png";